import moment from "moment";

export const TIME_ZONE = "America/Toronto";
const formatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit",
  hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
});
const parts = (value) => Object.fromEntries(formatter.formatToParts(new Date(value))
  .filter((part) => part.type !== "literal").map((part) => [part.type, part.value]));
const pad = (value) => String(value).padStart(2, "0");

export function torontoDate(value = new Date()) {
  const p = parts(value);
  return `${p.year}-${p.month}-${p.day}`;
}

export function formatToronto(value, format = "DD/MM/YYYY [at] hh:mm A") {
  if (!value || !Number.isFinite(new Date(value).getTime())) return "";
  const p = parts(value);
  // UTC is only used as a container for Toronto clock fields, never as the display zone.
  return moment.utc(`${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:${p.second}`).format(format);
}

// react-datepicker reads local fields. These Dates represent calendar selections,
// not instants, and must be explicitly converted before sending them to the API.
export function calendarDate(value) {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
}
export const torontoToday = () => calendarDate(torontoDate());
export const calendarKey = (value) => `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;

export function torontoInstant(date, clock = "00:00:00") {
  const target = Date.parse(`${date}T${clock}Z`);
  let instant = target;
  for (let i = 0; i < 4; i++) {
    const p = parts(instant);
    const local = Date.parse(`${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:${p.second}Z`);
    const correction = target - local;
    if (!correction) return new Date(instant);
    instant += correction;
  }
  throw new Error("This time does not exist in Toronto on the selected date.");
}

export function calendarBoundary(value, endOfDay = false) {
  if (!value) return null;
  const date = new Date(value);
  if (endOfDay) date.setDate(date.getDate() + 1);
  return new Date(torontoInstant(calendarKey(date)).getTime() - (endOfDay ? 1 : 0));
}

// Recurring stop clocks use a neutral winter date, avoiding the visitor's DST gaps.
export function pickupClock(value) {
  if (!value) return null;
  const p = parts(value);
  return new Date(2000, 0, 15, Number(p.hour), Number(p.minute), Number(p.second));
}
export function storedPickupClock(value) {
  return value ? torontoInstant("2000-01-15", `${pad(value.getHours())}:${pad(value.getMinutes())}:00`) : null;
}

export function routeCalendarDate(value) {
  // Continue accepting old timestamp links; new links carry a timezone-free date.
  return calendarDate(/^\d{4}-\d{2}-\d{2}$/.test(value) ? value : torontoDate(Number(value)));
}
